import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category?q=${encodeURIComponent(q)}` : '/category');
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20cinematic%20abstract%20background%20evoking%20a%20Japanese%20film%20world%20at%20night%2C%20deep%20indigo%20and%20midnight%20blue%20tones%20with%20soft%20warm%20amber%20light%20streaks%2C%20subtle%20film%20grain%2C%20elegant%20minimal%20composition%20with%20plenty%20of%20dark%20negative%20space%20for%20text%20overlay%2C%20dreamy%20bokeh%2C%20high%20detail%2C%20tasteful%20and%20refined%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=bhhero-main-v2&orientation=landscape"
          alt="北条麻妃电影 品牌视觉背景"
          title="北条麻妃电影 - 专业影视作品资讯平台"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/45 to-foreground-950/70"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="animate-fade-in inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          <i className="ri-award-line text-accent-300"></i>
          专注整理北条麻妃影视作品与行业资讯
        </span>
        <h1 className="animate-fade-up mt-6 text-3xl font-extrabold leading-tight tracking-tight text-background-50 md:text-5xl lg:text-6xl">
          北条麻妃电影
          <span className="mt-2 block text-xl font-semibold text-background-100 md:text-3xl">
            作品大全 · 剧情介绍 · 最新资讯
          </span>
        </h1>
        <p className="animate-fade-up mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          全面收录北条麻妃的影视作品资料，支持按类型、年代、国家多维筛选，快速找到你想了解的那部电影。
        </p>

        <form onSubmit={submit} className="animate-fade-up mt-8 w-full max-w-xl">
          <div className="flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/95 p-1.5 pl-4 backdrop-blur-md">
            <i className="ri-search-line text-lg text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              placeholder="输入电影标题关键词，例如： 潮汐之间"
              aria-label="搜索电影标题"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="shrink-0 rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap md:px-6"
            >
              搜索
            </button>
          </div>
        </form>

        <div className="animate-fade-up mt-8 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            onClick={() => navigate('/category')}
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-apps-2-line text-base"></i>
            浏览全部作品
          </button>
          <button
            type="button"
            onClick={() => navigate('/news')}
            className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 whitespace-nowrap"
          >
            <i className="ri-newspaper-line text-base"></i>
            查看最新资讯
          </button>
        </div>

        <div className="animate-fade-in mt-12 grid w-full max-w-2xl grid-cols-3 gap-4 border-t border-background-50/20 pt-8">
          {[
            { value: '16', label: '收录作品' },
            { value: '6', label: '作品类型' },
            { value: '8', label: '资讯动态' },
          ].map((s) => (
            <div key={s.label} className="flex flex-col items-center">
              <span className="text-2xl font-extrabold text-background-50 md:text-3xl">
                {s.value}
              </span>
              <span className="mt-1 text-xs text-background-100/80">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}